import React, { useState } from 'react';
import { Box, Button, VStack, Heading, Span } from '@bpba/ui-components';
import { useMutation, useQuery } from '@apollo/client';
import { Mutations } from '../rest/Mutations';
import { Sucursal } from '../rest/models/Sucursal';
import { Partido } from '../rest/models/Partido';
import { Queries } from '../rest/Queries';
import { getLocalidadesSuc } from '../rest/queries/getLocalidadesSuc';
import { getSucursales } from '../rest/queries/getSucursales';
import { getPartidosSuc } from '../rest/queries/getPartidosSuc';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Localidad } from '../rest/models/Localidad';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { ProvinciaComprasModel } from "../rest/models/ProvinciaComprasModel";
import { postProvinciaCompras } from "../rest/mutations/postProvinciaCompras";
import { postEsClienteProvinciaCompras } from "../rest/mutations/postEsClienteProvinciaCompras";
import { ProvinciaComprasRQ } from '../rest/models/ProvinciaComprasRQ';
import { EsClienteRQ } from '../rest/models/EsClienteRQ';
import { Result } from './Result';
import { ResultExito } from './ResultExito';
import { ResultError } from './ResultError';
import { getDetalleSucursalUbicom } from '../rest/queries/getDetalleSucursalUbicom';

const ProvinciaComprasComponente: React.FC = () => {

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let origenSolicitud = params.get('origenSolicitud');
    const { executeRecaptcha } = useGoogleReCaptcha();
    const { register, handleSubmit, reset, resetField, setValue, formState: { errors } } = useForm<any>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        defaultValues: {
        }
    });

    const REQUIRED_FIELD = "Campo requerido.";
    /* eslint-disable */
    const mailValidator = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const numberValidator = /^\d+$/;
    const [idProvinciaSuc, setIdProvinciaSuc] = useState<string>();
    const [idLocalidadSuc, setIdLocalidadSuc] = useState<string>();
    const [idPartidoSuc, setIdPartidoSuc] = useState<string>();
    const [ubicom, setUbicom] = useState<string>();
    const { data: { localidadesSuc } = {} } = useQuery<Queries>(getLocalidadesSuc, { variables: { idPartido: idPartidoSuc }, skip: !idPartidoSuc });
    const { data: { partidosSuc } = {} } = useQuery<Queries>(getPartidosSuc, { variables: { idProvincia: idProvinciaSuc }, skip: !idProvinciaSuc });
    const { data: { sucursales } = {} } = useQuery<Queries>(getSucursales, { variables: { idLocalidadSuc: idLocalidadSuc, filterBranch: 1 }, skip: !idLocalidadSuc });
    const { data: { detalleSucursalUbicom } = {} } = useQuery<Queries>(getDetalleSucursalUbicom, { variables: { ubicom: ubicom }, skip: !ubicom });
    const [postProvinciaComprasAPI, { loading: loadingCompra }] = useMutation<Mutations>(postProvinciaCompras);
    const [postEsClienteProvinciaComprasAPI, { loading: loadingEsClienteCompras }] = useMutation<Mutations>(postEsClienteProvinciaCompras);
    const [vistaSucursal, setVistaSucursal] = useState<boolean>(false);
    const [sucursalCliente, setSucursalCliente] = useState<number>(0);
    const [razonSocialCliente, setRazonSocialCliente] = useState<string>("");
    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<string>("");
    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<string>("");
    const [cuitValidado, setCuitValidado] = useState<boolean>(false);
    const [showFullForm, toggleFullForm] = useState<boolean>(false);

    function BuscPartidosSuc(formId: string) {
        setIdProvinciaSuc(formId.split('-')[0]);
        setIdPartidoSuc('');
        setIdLocalidadSuc('');
        resetField('localidadSuc');
        resetField('sucursal');
    }

    function BuscLocSuc(formId: string) {
        setIdPartidoSuc(formId.split('-')[0]);
        if (formId === '') {
            setIdLocalidadSuc('');

        }
        resetField('localidadSuc');
        resetField('sucursal');
    }
    function BuscSuc(formId: string) {
        setIdLocalidadSuc(formId.split('-')[0]);
        resetField('sucursal');
    }

    const ValidarCuit = async (data: ProvinciaComprasModel) => {
        const token = executeRecaptcha && (await executeRecaptcha('ProvinciaCompras'));

        let datos: EsClienteRQ = {
            "cuit": Number(data.cuit),
            "googleToken": token,
        }

        postEsClienteProvinciaComprasAPI({ variables: { input: datos } }).then((response: any) => {

            if (response !== null || response !== undefined) {
                setValue("razonSocial", response.data.EsClienteRQ.razonSocial);
                setRazonSocialCliente(response.data.EsClienteRQ.razonSocial);
                if (response.data.EsClienteRQ.ubicom === 0 || response.data.EsClienteRQ.ubicom === -1) {
                    setCuitValidado(true);
                    toggleFullForm(true);
                }
                else if (response.data.EsClienteRQ.sucursal != -1) {
                    setSucursalCliente(response.data.EsClienteRQ.ubicom);
                    setUbicom(response.data.EsClienteRQ.ubicom);
                    toggleFullForm(true);
                    setVistaSucursal(true);
                    setCuitValidado(true);
                }
            } else {
                setServicioOk(true);
                setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");


            }

        }).catch((e: any) => {

            if (e.networkError.statusCode === 409) {
                //entiendo que el cuit no es cliente entonces lo dejo elegir sucursal y que llene sus datos
                setCuitValidado(true);
                toggleFullForm(true);

            } else {

                setServicioOk(false);
                setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");
            }
        })
    }

    const onSubmit: SubmitHandler<ProvinciaComprasModel> = async (data: ProvinciaComprasModel) => showFullForm ? SubmitForm(data) : ValidarCuit(data)


    const SubmitForm: SubmitHandler<ProvinciaComprasModel> = async (data: ProvinciaComprasModel) => {

        const token = executeRecaptcha && (await executeRecaptcha('ProvinciaCompras'));

        let datos: ProvinciaComprasRQ = {
            "razonSocial": data.razonSocial ? data.razonSocial : razonSocialCliente,
            "origenSolicitud": origenSolicitud ? origenSolicitud : "",
            "cuit": data.cuit,
            "email": data.email,
            "telefonoContacto": (data.telefonoArea + data.telefono).toString(),
            "sucursal": Number(data.sucursal) ? Number(data.sucursal) : sucursalCliente,
            "localidad": data.localidadSuc,
            "condicionImpositiva": "0",
            "esComerciante": true,
            "tipoTramite": "28",
            "googleToken": token,
            "nombreContactoEmpresa": data.nombreContactoEmpresa,
            "nombre": data.nombre,
        }

        postProvinciaComprasAPI({ variables: { input: datos } }).then((response: any) => {

            if (response !== null || response !== undefined) {

                setServicioOk(true);
                if (response.data.ProvinciaComprasRQ.resultado === "ok") {
                    setMensajeRtaServicio("Solicitud creada con éxito.En los próximos días nos contactaremos con vos.");
                } else if (response.data.ProvinciaComprasRQ.error.toUpperCase().includes("ya tiene una solicitud".toUpperCase())) {
                    
                    setMensajeRtaServicio(response.data.ProvinciaComprasRQ.error);
                } else {

                    
                    setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
                }
            } else {
                setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");


            }

        }).catch(() => {

            setServicioOk(false);
            setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");

        })
    }


    const handleReset = () => {
        reset({});
        window.location.reload();
    };

    if (loadingCompra || loadingEsClienteCompras) return <SpinnerCajas />;
    if (servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultExito message={mensajeRtaServicio}></ResultExito>
        </Result>
    );
    if (mensajeErrorPostProspecto !== "" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>

    );





    return (
        <Box>
            <VStack>
                <form onSubmit={handleSubmit(onSubmit)}>
                    {!cuitValidado ?

                        (<>
                            <Heading level={3} mb={'2px'} fontWeight={400} tabIndex={0}>
                                Datos Generales
                            </Heading>
                            <VStack mt={"20px"}>

                                <input {...register(`cuit`, { required: REQUIRED_FIELD, minLength: { value: 11, message: "Debe tener al menos 11 dígitos" }, pattern: { value: numberValidator, message: "El campo debe ser numérico" } })} maxLength={11} name='cuit' type={"text"} defaultValue={""} placeholder='CUIT' />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.cuit ? "* " + errors.cuit.message : ""}</Span>
                            </VStack>
                            <Button type="submit" variant="secondary" py={"10px !important"}>Validar</Button>

                        </>)
                        : (<>
                            <Heading level={3} mb={'2px'} fontWeight={400} tabIndex={0}>
                                Datos Generales
                            </Heading>
                            <VStack mt={"20px"}>

                                <input {...register(`cuit`, { required: REQUIRED_FIELD, minLength: { value: 11, message: "Debe tener al menos 11 dígitos" }, pattern: { value: numberValidator, message: "El campo debe ser numérico" } })} maxLength={11} name='cuit' type={"text"} defaultValue={""} placeholder='CUIT' disabled />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.cuit ? "* " + errors.cuit.message : ""}</Span>
                            </VStack>
                            {!razonSocialCliente ?

                                (<VStack mt={"20px"}>
                                    <input {...register(`razonSocial`, { required: REQUIRED_FIELD, maxLength: 50, minLength: 2 })} name='razonSocial' type={"text"} placeholder='Razón social' maxLength={50} />
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.razonSocial ? "* " + errors.razonSocial.message : ""}</Span>
                                </VStack>) :
                                (<VStack mt={"20px"}>
                                    <input {...register(`razonSocial`, { required: REQUIRED_FIELD, maxLength: razonSocialCliente?.length })} name='razonSocial' type={"text"} value={razonSocialCliente} placeholder='Razón social' disabled />
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.razonSocial ? "* " + errors.razonSocial.message : ""}</Span>
                                </VStack>)}

                            <VStack mt={"20px"}>

                                <input {...register(`nombre`, { required: REQUIRED_FIELD, maxLength: 50, minLength: 5 })} name='nombre' type={"text"} defaultValue={""} placeholder='Nombre de fantasía' maxLength={50} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.nombre ? "* " + errors.nombre.message : ""}</Span>
                            </VStack>
                            <VStack mt={"20px"}>

                                <input {...register(`nombreContactoEmpresa`, { required: REQUIRED_FIELD, maxLength: 50, minLength: 5 })} name='nombreContactoEmpresa' type={"text"} defaultValue={""} placeholder='Nombre de contacto de la empresa' maxLength={50} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.nombreContactoEmpresa ? "* " + errors.nombreContactoEmpresa.message : ""}</Span>
                            </VStack>

                            <VStack mt={"20px"}>
                                <input type={'text'} {...register("email", { required: REQUIRED_FIELD, pattern: { value: mailValidator, message: "Formato de email inválido ejemplo: juana@mail.com" } })} name="email" placeholder='E-mail' maxLength={100} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.email ? "* " + errors.email.message : ""}</Span>
                            </VStack>

                            <VStack mt={"20px"}>
                                <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                    Teléfono de contacto
                                </Span>
                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mr={"0.5rem"}>
                                        <input type="text" style={{ width: "100%" }} {...register("telefonoArea", { required: REQUIRED_FIELD, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefonoArea" placeholder='Ej.: 11' maxLength={4} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefonoArea ? "* " + errors.telefonoArea.message : ""}</Span>
                                    </VStack>
                                    <VStack>
                                        <input type="text" tabIndex={0} style={{ width: "100%" }} {...register("telefono", { required: REQUIRED_FIELD, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefono" placeholder='Ej.: 4232424' maxLength={14} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefono ? "* " + errors.telefono.message : ""}</Span>
                                    </VStack>
                                </VStack>
                            </VStack>
                            {!vistaSucursal ?

                                (<>
                                    <VStack mt={"20px"}>
                                        <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>Sucursal</Span>

                                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                            <VStack mr={"0.5rem"}>
                                                <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad de la  sucursal"}
                                                    {...register("provinciaSuc", { required: REQUIRED_FIELD })}
                                                    onChange={(e) => BuscPartidosSuc(e.target.value)} name="provinciaSuc">
                                                    <option value="" >Seleccione una provincia</option>
                                                    <option value="2-Buenos Aires">Buenos Aires</option>
                                                    <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                                </select>

                                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                                    {errors.provinciaSuc ? "* " + errors.provinciaSuc.message : ""}
                                                </Span>
                                            </VStack>
                                            <VStack>
                                                <select tabIndex={0} aria-label={"Seleccione el partido de la  sucursal"} {...register("partidoSuc", { required: REQUIRED_FIELD })} onChange={(e) => BuscLocSuc(e.target.value)} name="partidoSuc"
                                                    defaultValue={""}>
                                                    <option value="" >Seleccione partido</option>
                                                    {partidosSuc &&
                                                        partidosSuc.map((item: Partido) =>
                                                            <option value={item.id_partido} key={item.desc_partido}>{item.desc_partido}</option>
                                                        )}
                                                </select>
                                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                                    {errors.partidoSuc ? "* " + errors.partidoSuc.message : ""}
                                                </Span>
                                            </VStack>
                                        </VStack>
                                        <VStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                            <VStack mr={"0.5rem"}>
                                                <select tabIndex={0} aria-label={"Seleccione la localidad de la  sucursal"} {...register("localidadSuc", { required: REQUIRED_FIELD })} onChange={(e) => BuscSuc(e.target.value)} name="localidadSuc"
                                                    defaultValue={""}>
                                                    <option value="" >Seleccione localidad</option>
                                                    {localidadesSuc &&
                                                        localidadesSuc.map((item: Localidad) =>
                                                            <option value={item.id_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                                        )}
                                                </select>

                                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                                    {errors.localidadSuc ? "* " + errors.localidadSuc.message : ""}
                                                </Span>
                                            </VStack>
                                            <VStack>
                                                <select tabIndex={0} aria-label={"Seleccione la  sucursal"} style={{ width: "100%" }} {...register("sucursal", { required: REQUIRED_FIELD })} name="sucursal" defaultValue={""}>
                                                    <option value="" disabled>Seleccione sucursal</option>
                                                    {sucursales &&
                                                        sucursales.map((item: Sucursal) =>
                                                            <option value={item.cod_ubic} key={item.suc_nombre}>{item.cod_ubic + " - " + item.suc_nombre}</option>
                                                        )}
                                                </select>
                                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                                    {errors.sucursal ? "* " + errors.sucursal.message : ""}
                                                </Span>
                                            </VStack>
                                        </VStack>
                                    </VStack>

                                </>) : (
                                    <VStack mt={"20px"}>
                                        <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>Sucursal</Span>
                                        <Span mb={"8px"} fontSize={"14px"} style={{ width: "100%", height: '2.5em' }} tabIndex={0}>{sucursalCliente}- {detalleSucursalUbicom?.suc_nombre} - {detalleSucursalUbicom?.domicilio}</Span>

                                    </VStack>
                                )}



                            <Button type="submit" variant="secondary" marginBottom={"24px"} style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'}>Enviar</Button>
                        </>)

                    }

                </form>
            </VStack>

        </Box>

    )

};



export default ProvinciaComprasComponente;